import React, { useState, useContext, createContext } from "react";
//   import { CartServices } from "../services/CartServices";

// ** Services Import
import { OrdersServices } from "../services/OrdersServices";
import { getInfoFromGoogleMap } from "../utils";

// ** Hooks Imports
import { useAuth } from "./useAuth";
import { useCart } from "./useCart";
import { useLanguage } from "./useLanguage";

const orderContext = createContext();

export function ProviderOrder({ children }) {
  const order = useProviderOrder();
  return (
    <orderContext.Provider value={order}>{children}</orderContext.Provider>
  );
}

export const useOrder = () => {
  return useContext(orderContext);
};

// Provider hook that creates Cart object and handles state
function useProviderOrder() {
  // ** Hooks
  const { userSecure } = useAuth();
  const { language } = useLanguage();
  const { getCart } = useCart();
  /**
   *  State
   */
  const [orders, setOrder] = useState({
    items: [],
    orderLoading: true,
    nextUrl: null
  });
  const [orderStatus, setOrderStatus] = useState({ loading: true, items: [] });

  const getOrderNextPage = ({ url }) => {
    return new Promise((resolve, reject) => {
      OrdersServices.getMyOrdersNextPage({
        token: userSecure.access_token,
        url: url
      })
        .then((result) => {
          const { data } = result;
          console.log("data", data);
          if (Array.isArray(data?.data)) {
            resolve({ items: data?.data, nextPage: data?.links?.next });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getProviderLocation = ({ lat, long }) => {
    return new Promise((resolve, reject) => {
      getInfoFromGoogleMap({
        latlong: `${lat},${long}`,
        language: `${language}`
      })
        .then((resultMap) => {
          const {
            street_address,
            route,
            locality,
            administrative_area_level_1,
            cityInfo
          } = resultMap?.cleanData;

          const fullAddress = {
            locality: null,
            street_address: null,
            administrative_area_level_1: null,
            route: null
          };
          if (locality && locality?.formatted_address) {
            fullAddress.locality = locality?.formatted_address;
          }
          if (street_address) {
            fullAddress.street_address = street_address;
          }
          if (
            administrative_area_level_1 &&
            administrative_area_level_1?.formatted_address
          ) {
            fullAddress.administrative_area_level_1 =
              administrative_area_level_1?.formatted_address;
          }
          if (route && route?.formatted_address) {
            fullAddress.route = route?.formatted_address;
          }

          const data = {
            fullAddress: { ...fullAddress },
            cityInfo
          };
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getMyOrders = () => {
    OrdersServices.getMyOrders({ token: userSecure.access_token })
      .then((result) => {
        const { data } = result;
        setOrder({
          items: [...data?.data] || [],
          orderLoading: false,
          nextUrl: data?.links?.next
        });
      })
      .catch((error) => {});
  };

  // ** Create New Order
  const createOrder = ({ providerID, formData,url_key }) => {
    return new Promise((resolve, reject) => {
      OrdersServices.createNewOrder({
        token: userSecure.access_token,
        providerID: providerID,
        formData: formData,
        url_key:url_key
      })
        .then(async (result) => {
          resolve(result);
          await getCart();
          await getMyOrders();
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  // RE Order
  const reOrder = (orderID) => {
    return new Promise((resolve, reject) => {
      OrdersServices.reOrder({
        orderID: orderID,
        token: userSecure.access_token
      })
        .then((result) => {
          getMyOrders();
          resolve(result);
        })
        .catch((error) => {
          console.log("error", error);
          reject(error);
        });
    });
  };

  // ** Send Message
  const customerSendMessage = ({ orderID, message }) => {
    return new Promise((resolve, reject) => {
      OrdersServices.customerSendMessage({
        orderID: orderID,
        token: userSecure.access_token,
        message: message
      })
        .then((result) => {
          resolve({data:result});
        })
        .catch((error) => {
          reject({error});
        });
    });
  };

  // ** Add Coupon Discount in the Order
  const addCouponDiscountInOrder = ({providerID,copounCode}) => {
    return new Promise((resolve, reject) => {
      OrdersServices.addCouponDiscountInOrder({
        providerID, copounCode,
        token: userSecure.access_token,
      })
        .then((result) => {
          const {data} = result;
          let status = false;
          let responseData = {};
          if("copoun_id" in data) {
            status = true;
            responseData = data;
          }else{
            status = false;
          }
          resolve({massage:data.massage || "",status:status,responseData,allData:data});
        })
        .catch((error) => {
          reject({massage:"O",status:false});
        });
    });
  }

  return {
    orders,
    orderStatus,
    setOrderStatus,
    setOrder,
    getOrderNextPage,
    getProviderLocation,
    createOrder,
    getMyOrders,
    reOrder,
    customerSendMessage,
    addCouponDiscountInOrder
  };
}
